<template>
    <div class="header-info">
        <div class="title-group d-flex">
        <!-- <div class="justify-start align-center">
            <h3>{{ listingId }}</h3>: <h4 class="font-weight-thin">{{ title }}</h4> -->
            <div class="justify-start align-start">
                <h2>{{ listingId }}</h2><br>
                <h4 class="font-weight-thin">{{ title }}</h4>
        
            <!-- <h3 class="font-weight-medium">{{ title }}</h3> -->
      </div>
      <v-spacer></v-spacer>
      <!-- <div class="justify-end align-center text-right"> -->
      <div class="justify-end align-start text-right">
        <!-- <h2>{{ listingId }}</h2><br> -->
        <h5 class="d-block font-weight-medium">Listing Stage: <span class="font-weight-bold">{{ stage }}</span></h5>
        <v-chip
          class="my-1 px-5 font-weight-thin"
          color="accent"
          text-color="general_grey">
          {{ acceptingApplications }}
        </v-chip>
      </div>
    </div>

    <div class="listing-data">
      <div class="cell one">
        <div class="cell_content">
          <div class="listing-data-value" v-if="listingStatus !== 2">
            {{type}}
          </div>
          <div class="listing-data-value" v-if="listingStatus == 2">
            -
          </div>
          <div class="listing-data-key" :style="{'color':'rgba(239,93,76,1)'}">
            Practice Type
          </div>
        </div>
      </div>

    <div class="cell two">
        <div class="cell_content">
            <div class="listing-data-value" v-if="listingStatus !== 2">
                {{ assetValue | currency }}
            </div>
            <div class="listing-data-value" v-if="listingStatus == 2">
                -
            </div>
            <div class="listing-data-key" :style="{'color':'#97C131'}">
                {{ assetLabel }}
            </div>
        </div>
    </div>

      <div class="cell three">
        <div class="cell_content">
          <div class="listing-data-value" v-if="listingStatus !== 2">
            <span>{{ t12AsOfValue ? t12AsOfValue : revenue }}</span>
          </div>
          <div class="listing-data-value" v-if="listingStatus == 2">
            -
          </div>
          <div class="listing-data-key" :style="{'color':'rgb(24,151,166)'}">
            <span>{{ t12AsOfDate ? `T12 as of ${t12AsOfDate}` : `Revenue` }}</span>
          </div>
        </div>
      </div>

      <div class="cell four no-line">
        <div class="cell_content">
          <div class="listing-data-value" v-if="listingStatus !== 2">
            {{ price }}
          </div>
          <div class="listing-data-value" v-if="listingStatus == 2">
            -
          </div>
          <div class="listing-data-key">
            Listing Price
          </div>
        </div>
      </div>

    </div>

    <div class="content-body">
      <span v-html="description"></span>
      <span v-if="!description">&nbsp;</span>
    </div>

    <div class="buttons">
      <v-btn
        v-if="(![2,3,4].includes(listingStatus) && acceptingFlag) && (!interest && canExpress)"
        class="secondary font-weight-bold mr-3"
        @click="$emit('update')">
        Express Interest
      </v-btn>

      <v-btn
        v-if="![2,3,4].includes(listingStatus) && (interest || !canExpress || !acceptingFlag)"     
        color="grey lighten-1"
        class="elevation-0 font-italic font-weight-black grey--text mr-3">
        {{ interest || !canExpress ? `Already Expressed Interest` : !acceptingFlag ? 'Not Accepting Applications' : `Express Interest` }}
      </v-btn>

      <v-btn 
        v-if="![2,3,4].includes(listingStatus) && downloadProspectus"
        class="secondary--text font-weight-bold"
        style="background-color: white"
        outlined
        elevation="1" 
        @click="$emit('download')">
        Download Prospectus
      </v-btn>

      <button class="get-notified-button" @click="!canExpress ? $emit('completeProfile') : $emit('notify')" v-if="listingStatus == 2 && !notified">
        <v-icon med :color="'rgb(24,151,166)'">mdi-bell</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;Get Notified
      </button>

      <button class="already-notified-button" v-if="listingStatus == 2 && notified && canExpress" >
        <v-icon med :color="'rgb(24,151,166)'">mdi-bell</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;Notification Sent!
      </button>


    </div>


    <div class="seperator" v-if="listingStatus !== 4 && listingStatus !== 3 && listingStatus !== 2">
      <v-icon med :color="'white'" class="seperator-icon">mdi-chevron-down</v-icon>
    </div>


  </div>
</template>

<script>
  export default {
    name: 'BuyerListingDetailsHeaderInfo',
    props: {
      insuranceBasedListings: Array,
      taxBasedListings: Array,
      practiceType: Number,
      notified: String,
      listingStatus: Number,
      price: String,
      listingId: String,
      title: String,
      status: String,
      acceptingFlag: Boolean,
      stage: String,
      aum: String,
      aua: String,
      revenue: String,
      averageFee: String,
      type: String,
      favorited: Boolean,
      interest: Boolean,
      canExpress: Boolean,
      description: String,
      t12AsOfDate: String,
      t12AsOfValue: String,
      downloadProspectus: Boolean
    },
    data() {
      return {
      }
    },

    computed: {
      heartColor () {
        return this.favorited ? "warning" : "#999999"
      },
      acceptingApplications () {
        return this.acceptingFlag ? 'Accepting Applications' : 'Not Accepting Applications'
      },
      assetLabel () {
        if ( this.insuranceBasedListings.includes(this.practiceType) ) {
          return 'Average Commission'
        } else if ( this.taxBasedListings.includes(this.practiceType) ) {
          if ( this.aum && this.aua )       return 'AUM + AUA'
          else if ( this.aum && !this.aua ) return 'AUM'
          else if ( !this.aum && this.aua ) return 'AUA'
        } else if ( this.aum ) {
          return 'AUM'
        }
      },
      assetValue () {
        if ( this.insuranceBasedListings.includes(this.practiceType) ) {
          return this.averageFee
        } else if ( this.taxBasedListings.includes(this.practiceType) ) {
          if ( this.aum && this.aua )       return JSON.parse(this.aum)+JSON.parse(this.aua)
          else if ( this.aum && !this.aua ) return this.aum
          else if ( !this.aum && this.aua ) return this.aua
        } else if ( this.aum ) {
          return this.aum
        }
      }
    }
  }
</script>

<style scoped>

  .seperator {
    width: 100%;
    margin-top: 20px;
    border-bottom: 1px solid lightGrey;
    text-align: center;
  }

  .seperator-icon {
    background: lightGrey;
    width: 35px;
    height: 35px;
    border-radius: 17.5px;
    margin-bottom: -20px;
    border: 5px solid #EFEFEF;
  }

  .express-interest-button {
    margin-bottom: 5px;
    padding: 10px 25px;
    background-color: #97C131;
    border-radius: 5px;
    color: white;
    text-transform: uppercase;
    font-family: 'SansationBold', sans-serif;
    margin-right: 25px;
    outline:none;
  }

  .download-prospectus-button {
    padding: 10px 25px;
    border: 2px solid #97C131;
    border-radius: 5px;
    background-color: white;
    color: #97C131;
    text-transform: uppercase;
    font-family: 'SansationBold', sans-serif;
    outline:none;
  }

  .get-notified-button {
    color: rgb(24,151,166);
    padding: 10px 25px;
    border: 2px solid rgb(24,151,166);
    border-radius: 5px;
    text-transform: uppercase;
    font-family: 'SansationBold', sans-serif;
    outline:none;
  }


  .already-notified-button {
    color: rgb(24,151,166);
    padding: 10px 25px;
    border: 2px solid rgb(24,151,166);
    border-radius: 5px;
    text-transform: uppercase;
    font-family: 'SansationBold', sans-serif;
    outline:none;
    cursor: default !important;
    opacity: .25;
  }

  .buttons {
    margin: 30px 0;
    /* margin-left: 25px; */
  }

  .header-info {
    /* width: 70%; */
    padding: 10px 10px 10px 30px;
  }

  .listing-data {
    /* display: grid; */
    width: 100%;
    display: block;
    float: left;
  }

  .listing-data .cell {
    display: inline;
    float: left;
    /* grid-row: 1; */
    border-right: 2px solid #DDD;
    margin: 3% 0;
  }

  .one {
    /* padding: 0 !important; */
    /* grid-column: 1 / 4; */
    text-align: left;
    padding: 0 3.5% 0 0;
  }

  .two {
    /* grid-column: 2 / 4; */
    text-align: center;
    padding: 0 3.5%;
  }

  .three {
    /* grid-column: 3 / 4; */
    text-align: center;
    padding: 0 3.5%;
  }

  .four {
    /* grid-column: 4 / 4; */
    text-align: center;
    padding: 0 3.5%;
  }

  .cell_content {
    text-align: center;
    padding: 0;
    margin: 0;
  }

  .no-line {
    border-right: none !important;
  }

  .listing-data-value {
    color: #5F6062;
    font-family: 'Sansation', sans-serif !important;
    font-size: 1.2rem;
  }

  .listing-data-key {
    font-family: 'Sansation', sans-serif !important;
    font-size: .8rem;
  }

  .header-info .title-group {
    color: #5F6062;
    font-family: 'SansationRegular', sans-serif;
  }

  .content-body {
    margin-top: 10px;
    font-size: .9rem;
    /* margin-left: 25px; */
  }

  .header-info .title-group h2 {
    font-family: 'SansationBold', sans-serif !important;
    /* margin-left: 25px; */
    font-size: 1.5rem;
    display: inline-block;
    font-weight: normal;
  }
  .header-info .title-group h3 {
    font-family: 'Sansation', sans-serif !important;
    font-size: 1.2rem;
    display: inline-block;
  }
  .header-info .title-group h4 {
    font-family: 'Sansation', sans-serif !important;
    font-size: 1.1rem;
    display: inline-block;
  }
  .header-info .title-group h5 {
    font-family: 'Sansation', sans-serif !important;
    font-size: .9rem;
    display: inline-block;
  }

  .interactions-group {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .interaction {
    margin: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .interaction span {
    color: #5F6062;
    font-family: 'SansationRegular', sans-serif;
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/header-info.vue